import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../constants/queryKeys";
import { getSupplyChainCredentials } from "../../api/supplyChain/getSupplyChainCredentials";
import { useSetAtom } from "jotai";
import { supplyChainTokenAtom } from "../../atoms/supplychain/supplyChainTokenAtom";
import { supplyChainExpirationAtom } from "../../atoms/supplychain/supplyChainExpirationAtom";

export const useSupplyChainCredentialsMutation = (userId?: number) => {
  const setSCToken = useSetAtom(supplyChainTokenAtom);
  const setSCExpiration = useSetAtom(supplyChainExpirationAtom);

  return useMutation({
    mutationKey: [QUERY_KEYS.GET_SUPPLY_CHAIN_CREDENTIALS, { userId }],
    mutationFn: async () => {
      return await getSupplyChainCredentials();
    },
    onSuccess: (response) => {
      setSCToken(response.sc_access_token);
      setSCExpiration(response.sc_expiration);
      return response;
    },
  });
};
